// extracted by mini-css-extract-plugin
export default {"wedding-date-field":"wedding-date-field--mp-eMpsr","weddingDateField":"wedding-date-field--mp-eMpsr","title":"title--mp-a47hz","divider":"divider--mp-bIVQm"};